import { QueryExportInput } from '../gql/graphql'
import { queryExportMutation } from '../queries/graphql/graphqlQueries'
import { stripQueryExportInput } from '../utils/tableConfigUtils'
import { apolloClient } from './apolloClient'

export type CustomFabricQueryConnection = {
  data: any[]
  endCursor: string
  totalCount: number
  startCursor: string
  hasNextPage: boolean
  hasPreviousPage: boolean
}

export type FabricQueryConnection = {
  data: any[]
  endCursor: string
  hasNextPage: boolean
}

export type QueryPayload =
  | any
  | FabricQueryConnection
  | CustomFabricQueryConnection
export interface QueryVariables
  extends FabricQueryVariables,
    CustomFabricQueryVariables {
  input: {
    filterCriteria?: FilterCriteria[]
    sortCriteria?: SortCriteria[]
  }
}

export const defaultPayload: any = {
  totalCount: 0,
  data: [],
  start: 0,
  end: 0,
  totalPages: 0,
  pageSize: 0,
}

export type SortCriteria = Record<string, unknown>

/**
 *  TODO: make always present columns required in future
 * need to make sure all consumption of filter criteria passes through the
 * standardizer/defaulter for values. This will reduce conditional checks
 * on filterCriteria fields across the app, as we'll ensure fields exist
 * at injestion..
 * */
export type FilterCriteria = Record<string, unknown>

export type FilterCriteriaOptions = Partial<FilterCriteria>

export type PostQueryOptions = Record<string, unknown>

export type FabricQueryInput = {
  first?: number
  after?: string | null
  filterCriteria?: FilterCriteria[]
  sortCriteria?: SortCriteria[]
}

export type FabricQueryVariables = {
  input?: FabricQueryInput
}
export type FabricQueryOptions = FabricQueryVariables & {
  selection?: string[]
}

export type CustomFabricQueryInput = {
  first?: number
  last?: number
  after?: string | null
  before?: string | null
  filterCriteria?: FilterCriteria[]
  sortCriteria?: SortCriteria[]
}

export type CustomFabricQueryVariables = {
  input?: CustomFabricQueryInput
}

export type CustomFabricQueryOptions = CustomFabricQueryInput & {
  selection?: string[]
}

export type Helo2QueryType = {
  queryType: 'helo2query'
  resultType: any
  variables: Record<string, unknown>
}

export type FabricQueryType = {
  queryType: 'fabricquery'
  resultType: FabricQueryConnection
  variables: FabricQueryVariables
  /** Required for variable injection... must be pulled from fabric gql */
  filterInputType: string
  /** Required for variable injection... must be pulled from fabric gql */
  orderByInputType: string
}

export type CustomFabricQueryType = {
  queryType: 'customfabricquery'
  resultType: CustomFabricQueryConnection
  variables: CustomFabricQueryVariables
}

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}

export type QueryType = Helo2QueryType | FabricQueryType
export type QueryTypeConfig = QueryType extends infer U
  ? U extends QueryType
    ? Omit<U, 'variables' | 'resultType'> & {
        queryType: U['queryType']
        variables?: Record<string, any>
        filterInputType?: string
        orderByInputType?: string
      }
    : never
  : never

export type ExportColumn = Record<string, unknown>

export const exportFile = async (exportOptions: QueryExportInput) => {
  try {
    const rawInput: QueryExportInput = {
      ...exportOptions,
      fileName:
        exportOptions.fileName ||
        `${exportOptions.queryDefinitionId}-export.csv`,
    }
    const input = stripQueryExportInput(
      rawInput as Record<string, unknown>,
    ) as QueryExportInput

    const result = await apolloClient.mutate({
      mutation: queryExportMutation as any,
      variables: { input },
    })
    if (result.error) {
      throw new Error(result.error.message)
    }
    return (result.data as { queryExport?: unknown } | undefined)?.queryExport
  } catch (e: unknown) {
    throw e
  }
}
